const bound = value => Math.max(-1, Math.min(1, value));
const difference = (value, origin) => ((value - origin + 540) % 360) - 180;

// Relative to the way the phone was held when enabled, in screen coordinates.
export function screenTilt(sample, origin, angle = 0) {
  if (![sample?.beta, sample?.gamma, origin?.beta, origin?.gamma, angle].every(Number.isFinite)) return null;
  const radians = angle * Math.PI / 180;
  const horizontal = difference(sample.gamma, origin.gamma), vertical = difference(sample.beta, origin.beta);
  return { x: bound((horizontal * Math.cos(radians) + vertical * Math.sin(radians)) / 24), y: bound((vertical * Math.cos(radians) - horizontal * Math.sin(radians)) / 24) };
}
